// EDEN · minimal DOM helpers.

/** HTML-escape untrusted text before interpolating into template strings. */
export function esc(value: unknown): string {
  return String(value ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

export function appRoot(): HTMLElement {
  const el = document.getElementById("app");
  if (!el) throw new Error("#app not found");
  return el;
}

/**
 * Block paste into a field so its text is the teacher's own English (ModuleD spec §2, §4.4).
 * Covers keyboard (Ctrl/Cmd+V) and context-menu paste (the `paste` event) plus drag-drop
 * (the `drop` event). Not a security control — the point is an honest written trajectory.
 */
export function lockPaste(el: HTMLElement | null): void {
  if (!el) return;
  el.addEventListener("paste", (e) => e.preventDefault());
  el.addEventListener("drop", (e) => e.preventDefault());
  el.addEventListener("dragover", (e) => e.preventDefault());
}
